<template>
  <van-tabs line-height="1" shrink>
    <van-tab title="用户注册">
      <van-form class="mt10" ref="form">
        <van-field
          v-model="registInfo.companyID"
          label="新公司ID"
          placeholder="新公司ID"
          :rules="[{ required: true, message: '请填写新公司ID' }]"
        />
        <van-field
          v-model="registInfo.name"
          label="公司注册名称"
          placeholder="公司注册名称"
          :rules="[{ required: true, message: '请填写公司注册名称' }]"
        />
        <van-field
          v-model="registInfo.address"
          is-link
          readonly
          label="注册所在地"
          placeholder="注册所在地"
          :rules="[{ required: true, message: '请选择注册所在地' }]"
          @click="showCountyPicker=true"
        />
        <van-field
          v-model="registInfo.taxType"
          label="税制归属国家"
          placeholder="税制归属国家"
          @click="showTaxCountyPicker=true"
        />
        <van-field
          v-model="registInfo.taxpayer"
          is-link
          readonly
          label="税制类别"
          placeholder="税制类别"
          :rules="[{ required: true, message: '请选择税制类别' }]"
          @click="showTaxSystemPicker=true"
        />
        <van-field
          v-model="registInfo.currency"
          is-link
          readonly
          label="统计货币"
          placeholder="统计货币"
          :rules="[{ required: true, message: '请选择统计货币' }]"
          @click="showCurrencyPicker=true"
        />
        <div style="margin: 16px;">
          <van-button block type="primary" native-type="button" @click="save">确认注册</van-button>
          <van-button class="mt10" block type="primary" native-type="button" plain @click="jump">跳过此步，完成注册</van-button>
        </div>
      </van-form>
      <!--注册所在地-->
      <van-popup v-model="showCountyPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="registCountryList"
          @cancel="showCountyPicker = false"
          @change="dataChange"
          @confirm="confirmCountry"
        />
      </van-popup>
      <!--税制归属国家-->
      <van-popup v-model="showTaxCountyPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="taxCountryList"
          @cancel="showTaxCountyPicker = false"
          @confirm="confirmCountry"
        />
      </van-popup>
      <!--税制类别-->
      <van-popup v-model="showTaxSystemPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="taxSystemList"
          @cancel="showTaxSystemPicker = false"
          @confirm="confirmTaxSystem"
        />
      </van-popup>
      <!--统计货币-->
      <van-popup v-model="showCurrencyPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="currencyData"
          @cancel="showCurrencyPicker = false"
          @confirm="confirmCurrency"
        />
      </van-popup>
    </van-tab>
  </van-tabs>
</template>
<script>
  import vuePickers from 'vue-pickers'
  import {getCurrencyApi, getCountryApi, getProvinceApi, getCityApi} from '@/api/common'

  export default {
    name: "res2",
    components: {
      vuePickers
    },
    data() {
      return {
        showCountyPicker: false,//城市选择弹窗
        showTaxSystemPicker: false,//税制类别选择弹窗
        showCurrencyPicker: false,//货币选择弹窗
        showTaxCountyPicker: false,//税制归属国家弹窗
        registCountryList: [],//注册国家数据
        taxCountryList: [],
        currencyData: [],//统计货币数据
        taxSystemList: [
          {
            text: '一般纳税人',
            value: '一般纳税人'
          },
          {
            text: '小规模纳税人',
            value: '小规模纳税人'
          }
        ],
        registInfo: {
          companyID: '',//新公司ID
          name: '',//注册名称
          address:"",//地址
          country:"",//国家
          province: "",//省
          city:"",//市
          district:"",//区/县
          taxType: '中国',//税制归属国家
          taxpayer: '',//税制类别
          currency: '',//统计货币
          temp:'',//操作标识
        },
      }
    },
    mounted() {
      this.getCurrency();//统计货币
      this.createCountryData();//国家
    },
    methods: {
      //选择统计货币
      confirmCurrency(item) {
        this.registInfo.currency = item.value;
        this.showCurrencyPicker = false;
      },
      //选择税制类别
      confirmTaxSystem(item) {
        this.registInfo.taxpayer = item.value;
        this.showTaxSystemPicker = false;
      },
      //选择注册国家
      confirmCountry(item) {
        this.registInfo.country=`${item[0]}`;
        this.registInfo.province=`${item[1] ? item[1] : ''}`;
        this.registInfo.city=`${item[2] ? item[2] : ''}`;
        this.registInfo.address = `${item[0]}${item[1] ? item[1] : ''}${item[2] ? item[2] : ''}`;
        this.showCountyPicker = false;
      },
      async dataChange(picker, values) {
        let province = await this.getRegisterProvince(values[0]);
        picker.setColumnValues(1, province);
        if (province.length) {
          let city = await this.getRegisterCity(province[0]);
          picker.setColumnValues(2, city);
        } else {
          picker.setColumnValues(2, []);
        }
      },
      async createCountryData() {
        let country = await this.getRegisterCountry();
        let province = await this.getRegisterProvince(country[0]);
        let city = await this.getRegisterCity(province[0]);

        this.registCountryList = [{values: country}, {values: province}, {values: city}];
      },
      //注册国家
      async getRegisterCountry() {
        let response = await getCountryApi();
        if (response.success) {
          let country = [];
          response.result.forEach(item => {
            country.push(item.areaValue)
          });
          return country;
        }
      },
      //省
      async getRegisterProvince(country) {
        let params = {
          country
        };
        let response = await getProvinceApi(params);
        if (response.success) {
          let province = [];
          response.result.forEach(item => {
            province.push(item.areaValue)
          });
          return province;
        }
      },
      //市
      async getRegisterCity(province) {
        let params = {
          province
        };
        let response = await getCityApi(params);
        if (response.success) {
          let city = [];
          response.result.forEach(item => {
            city.push(item.areaValue)
          });
          return city;
        }
      },
      //货币
      async getCurrency() {
        let response = await getCurrencyApi();
        if (response.success) {
          response.result.forEach(item => {
            this.currencyData.push({
              text: item.Code,
              value: item.Code
            })
          });
        }
      },
      //点击保存或者跳过
      save() {
        // 全局表单验证
        this.$refs.form.validate().then(async () => {
          this.registInfo.temp="A";
          //触发父组件save事件
          this.$emit('save', this.registInfo)
        }).catch(() => {
          //this.$toast.fail('提交失败')
        })
      },
      jump() {
        this.registInfo.temp="B";
        //触发父组件save事件
        this.$emit('save', this.registInfo);
      }
    }
  }
</script>
